export default "__VITE_ASSET__5564AtNI__"